import React from "react";

// ANT DESIGN IMPORT
import { Row, Tag, Card, Col, Statistic } from "antd";
import {
  CheckCircleOutlined,
  SyncOutlined,
  PlusOutlined,
  CloseCircleOutlined,
  SafetyOutlined,
  EditOutlined,
  ClockCircleOutlined,
  CompassOutlined,
  SettingOutlined,
  DownloadOutlined,
  UndoOutlined,
  SwapOutlined,
  UploadOutlined,
  CalculatorOutlined,
  WalletOutlined,
  RollbackOutlined,
  HolderOutlined,
  DoubleRightOutlined,
  ArrowLeftOutlined,
  DeleteOutlined,
  LikeOutlined,
  DislikeOutlined,
  MoneyCollectOutlined,
} from "@ant-design/icons";

//CURRENT ACCOUNT ANTD ICONS IMPORT
import { UserAddOutlined } from "@ant-design/icons";

//PROJECT IMPORT
import { BOM } from "../../services/definedMethod";

export const AccountFacility = (props) => {
  const { accountName, accountNo, status, subStatus, productName, accDetail } =
    props;

  return (
    <Card
      bordered={true}
      bodyStyle={{
        paddingTop: 12,
        paddingBottom: 12,
        // paddingLeft: 24,
      }}
      hoverable={true}
      style={{ marginBottom: 24, backgroundColor: "#EAE7EC" }}
    >
      <Row>
        <Col span={12}>
          <Statistic
            title={"Account Name"}
            value={accountName ? BOM.SubstringFormat(accountName, 20) : "-"}
            valueStyle={{
              fontSize: "16px",
            }}
          />

          <Statistic
            title={"Account Number"}
            value={" "}
            prefix={accountNo ? accountNo : "-"}
            valueStyle={{
              fontSize: "16px",
            }}
          />
        </Col>
        <Col span={12}>
          {status?.value
            ? handleFlgStatus(
                status?.value?.toLowerCase() === "premature closed"
                  ? "Early Termination"
                  : status?.value,
                {
                  fontSize: 16,
                },
                false,
                accDetail
              )
            : "-"}
        </Col>
      </Row>
    </Card>
  );
};

const statusStyles = {
  approved: {
    bgColor: "#EEF4FF",
    textColor: "#3538CD",
    border: "1px solid #C7D7FE",
  },
  active: {
    bgColor: "#ECFDF3",
    textColor: "#067647",
    border: "1px solid #ABEFC6",
  },
  success: {
    bgColor: "#f0f9ff",
    textColor: "#16a34a",
    border: "1px solid #87d068",
  },
  "active in bad standing": {
    bgColor: "#FEF3F2",
    textColor: "#FA0008",
    border: "1px solid #fca5a5",
  },
  rejected: {
    bgColor: "#FEF3F2",
    textColor: "#FA0008",
    border: "1px solid #fca5a5",
  },
  "premature closed": {
    bgColor: "#FEF3F2",
    textColor: "#FA0008",
    border: "1px solid #fca5a5",
  },
  closed: {
    bgColor: "#FEF3F2",
    textColor: "#FA0008",
    border: "1px solid #fca5a5",
  },
  default: {
    // bgColor: "#FFEB86",
    textColor: "black",
    border: "1px solid #FFEB86",
  },
};

export const handleFlgStatus = (
  status,
  style = {},
  isListing = false,
  otherParams = {}
) => {
  let statusKey = status.toLowerCase();
  let displayText = status;

  // Handle special case for active in arrears
  if (
    (statusKey === "active" || statusKey === "success") &&
    otherParams?.inArrears
  ) {
    statusKey = "active in bad standing";
    displayText = "Active in Bad Standing";
  }

  const styling = statusStyles[statusKey] || statusStyles.default;

  // Base style that will be applied to all tags
  const baseStyle = {
    padding: "2px 12px",
    borderRadius: "16px",
    border: styling.border,
    fontSize: "12px",
    fontWeight: 500,
    display: "inline-block",
    backgroundColor: styling.bgColor,
    color: styling.textColor,
    textTransform: "capitalize",
    ...style, // Allow override of any styles
  };

  // Get the appropriate icon
  const getIcon = () => {
    switch (statusKey) {
      case "approved":
        return <SafetyOutlined />;
      case "active":
      case "success":
      case "active in bad standing":
        return <CheckCircleOutlined />;
      case "rejected":
      case "premature closed":
      case "early termination":
      case "closed":
        return <CloseCircleOutlined />;
      default:
        return <ClockCircleOutlined />;
    }
  };

  const getColor = () => {
    if (!isListing) return undefined; // Don't use color prop when we have custom styling

    switch (statusKey) {
      case "approved":
        return "purple";
      case "active":
      case "success":
        return otherParams?.inArrears ? "red" : "success";
      case "rejected":
      case "premature closed":
      case "early termination":
      case "closed":
        return "red";
      default:
        return "warning";
    }
  };

  return (
    <Tag
      icon={getIcon()}
      color={isListing ? getColor() : undefined}
      style={baseStyle}
    >
      {statusKey === "default"
        ? BOM.SubstringFormat(displayText, 21)
        : displayText}
    </Tag>
  );
};

export const handleFlgSubStatus = (
  subStatus,
  style = {},
  isListing = false,
  otherParams = {}
) => {
  console.log(subStatus);
  const getNameFromValue = (value) => {
    const mapping = {
      block: "Blocked",
      blockcredit: "Credit Blocked",
      blockdebit: "Debit Blocked",
    };
    return mapping[value] || value;
  };
  const statusName = getNameFromValue(subStatus?.toLowerCase());
  if (subStatus?.toLowerCase() === "none") {
    return "--";
  }
  return (
    <Tag
      icon={<CloseCircleOutlined />}
      color={`${isListing ? "red" : "#FEF3F2"}`}
      style={{
        color: "#B42318",
        border: "1px solid #FECDCA",
        ...style,
      }}
    >
      {statusName}
    </Tag>
  );
};

export const handleSavingsAccActionButtons = (accDetail) => {
  const { fieldOfficerName } = accDetail;
  const status = accDetail?.status?.value;
  const subStatusBlock = accDetail?.subStatus?.block;
  const subStatusNone = accDetail?.subStatus?.none;
  switch (status.toLowerCase()) {
    case accountStatus.submittedAndPending:
      return [
        {
          label: "Modify Application",
          key: "1",
          route: "/savings-account-action",
          disabled: !BOM.HasPermission("UPDATE_SAVINGSACCOUNT"),
          icon: <EditOutlined />,
        },
        {
          label: "Approve",
          key: "2",
          route: "/savings-account-action",
          disabled: !BOM.HasPermission("APPROVE_SAVINGSACCOUNT"),
          icon: <SafetyOutlined />,
        },
        {
          label: "Reject",
          key: "3",
          route: "/savings-account-action",
          disabled: !BOM.HasPermission("REJECT_SAVINGSACCOUNT"),
          icon: <DislikeOutlined />,
        },
        {
          label: fieldOfficerName ? "Unassign Officer" : "Assign Officer",
          key: "4",
          route: "/savings-account-action",
          disabled: fieldOfficerName
            ? !BOM.HasPermission("REMOVESAVINGSOFFICER_SAVINGSACCOUNT")
            : !BOM.HasPermission("UPDATESAVINGSOFFICER_SAVINGSACCOUNT"),
          icon: <UserAddOutlined />,
        },

        {
          label: "Withdrawn by applicant",
          key: "5",
          route: "/savings-account-action",
          disabled: !BOM.HasPermission("WITHDRAW_SAVINGSACCOUNT"),
          icon: <SwapOutlined />,
        },
        {
          label: "Add Charge",
          key: "6",
          route: "/savings-account-action",
          disabled: !BOM.HasPermission("CREATE_SAVINGSACCOUNTCHARGE"),
          icon: <WalletOutlined />,
        },
      ];
    case accountStatus.approved:
      return [
        {
          label: "Undo Approval",
          key: "1",
          route: "/savings-account-action",
          disabled: !BOM.HasPermission("APPROVALUNDO_SAVINGSACCOUNT"),
          icon: <UndoOutlined />,
        },
        {
          label: "Activate",
          key: "2",
          route: "/savings-account-action",
          disabled: !BOM.HasPermission("ACTIVATE_SAVINGSACCOUNT"),
          icon: <CheckCircleOutlined />,
        },
        {
          label: "Add Charge",
          key: "3",
          route: "/savings-account-action",
          disabled: !BOM.HasPermission("CREATE_SAVINGSACCOUNTCHARGE"),
          icon: <WalletOutlined />,
        },
        {
          label: fieldOfficerName ? "Unassign Officer" : "Assign Officer",
          key: "4",
          route: "/savings-account-action",
          disabled: fieldOfficerName
            ? !BOM.HasPermission("REMOVESAVINGSOFFICER_SAVINGSACCOUNT")
            : !BOM.HasPermission("UPDATESAVINGSOFFICER_SAVINGSACCOUNT"),
          icon: <UserAddOutlined />,
        },
      ];
    case accountStatus.active:
      return [
        // {
        //   label: "Post Interest As On",
        //   key: "1",
        //   route: "/savings-account-action",
        //   disabled:
        //     subStatusBlock || !BOM.HasPermission("POSTINTEREST_SAVINGSACCOUNT"),
        //   icon: <DoubleRightOutlined />,
        // },
        {
          label: "Deposit",
          key: "2",
          route: "/savings-account-action",
          disabled:
            subStatusBlock || !BOM.HasPermission("DEPOSIT_SAVINGSACCOUNT"),
          icon: <UploadOutlined />,
        },
        {
          label: "Withdraw",
          key: "3",
          route: "/savings-account-action",
          disabled:
            subStatusBlock || !BOM.HasPermission("WITHDRAWAL_SAVINGSACCOUNT"),
          icon: <DownloadOutlined />,
        },
        {
          label: "Calculate Interest",
          key: "4",
          route: "/savings-account-action",
          disabled:
            subStatusBlock ||
            !BOM.HasPermission("CALCULATEINTEREST_SAVINGSACCOUNT"),
          icon: <CalculatorOutlined />,
        },
        {
          label: subStatusBlock ? "Unhold" : "Hold",
          key: "5",
          route: "/savings-account-action",
          icon: <HolderOutlined />,
          disabled: subStatusBlock
            ? subStatusNone || !BOM.HasPermission("UNHOLD_SAVINGSACCOUNT")
            : subStatusBlock || !BOM.HasPermission("HOLD_SAVINGSACCOUNT"),
        },
        {
          label: "Add Charge",
          key: "6",
          route: "/savings-account-action",
          disabled:
            subStatusBlock || !BOM.HasPermission("CREATE_SAVINGSACCOUNTCHARGE"),
          icon: <WalletOutlined />,
        },
        // {
        //   label: "Post Interest",
        //   key: "7",
        //   route: "/savings-account-action",
        //   disabled: subStatusBlock || !BOM.HasPermission("POSTINTEREST_SAVINGSACCOUNT"),
        //   icon: <SettingOutlined />,
        // },
        {
          label: fieldOfficerName ? "Unassign Officer" : "Assign Officer",
          key: "8",
          route: "/savings-account-action",
          disabled: fieldOfficerName
            ? !BOM.HasPermission("REMOVESAVINGSOFFICER_SAVINGSACCOUNT")
            : !BOM.HasPermission("UPDATESAVINGSOFFICER_SAVINGSACCOUNT"),
          icon: <UserAddOutlined />,
        },
        {
          label: "Close",
          key: "9",
          route: "/savings-account-action",
          disabled:
            subStatusBlock || !BOM.HasPermission("CLOSE_SAVINGSACCOUNT"),
          icon: <CloseCircleOutlined />,
        },
        {
          label: "New Standing Instructions",
          key: "10",
          route: "/savings-account-action",
          disabled: subStatusBlock,
          icon: <SettingOutlined />,
        },
        {
          label: "Transfer Funds",
          key: "11",
          route: "/savings-account-action",
          // disabled: true,
          disabled: subStatusBlock,
          icon: <UserAddOutlined />,
        },
      ];
    case accountStatus.block:
      return [
        {
          label: "Unhold Account",
          key: "1",
          route: "/unhold-account",
          disabled: !BOM.HasPermission("UNHOLD_SAVINGSACCOUNT"),
          icon: <HolderOutlined />,
        },
      ];
    case accountStatus.withdrawnByApplicant:
      return [
        {
          label: "Assign Staff",
          key: "1",
          route: "/savings-account-action",
          disabled: !BOM.HasPermission("UPDATESAVINGSOFFICER_SAVINGSACCOUNT"),
          icon: <UserAddOutlined />,
        },
        {
          label: "Unassign Staff",
          key: "2",
          route: "/savings-account-action",
          disabled: !BOM.HasPermission("REMOVESAVINGSOFFICER_SAVINGSACCOUNT"),
          icon: <UserAddOutlined />,
        },
      ];
    case accountStatus.closed:
      return [
        {
          label: fieldOfficerName ? "Change Officer" : "Assign Officer",
          key: "1",
          route: "/savings-account-action",
          disabled: !BOM.HasPermission("UPDATESAVINGSOFFICER_SAVINGSACCOUNT"),
          icon: <UserAddOutlined />,
        },
      ];
    default:
      return [];
  }
};

export const handleCurrentAccActionButtons = (accDetail) => {
  const { fieldOfficerName } = accDetail;
  const status = accDetail?.status?.value;
  const subStatusBlock = accDetail?.subStatus?.block;
  const subStatusNone = accDetail?.subStatus?.none;

  switch (status.toLowerCase()) {
    case accountStatus.submittedAndPending:
      return [
        {
          label: "Modify Application",
          key: "1",
          route: "/current-account-action",
          disabled: !BOM.HasPermission("UPDATE_SAVINGSACCOUNT"),
          icon: <SettingOutlined />,
        },
        {
          label: "Approve",
          key: "2",
          route: "/current-account-action",
          disabled: !BOM.HasPermission("APPROVE_SAVINGSACCOUNT"),
          icon: <SafetyOutlined />,
        },
        {
          label: fieldOfficerName ? "Unassign Officer" : "Assign Officer",
          key: "3",
          route: "/current-account-action",
          disabled: fieldOfficerName
            ? !BOM.HasPermission("REMOVESAVINGSOFFICER_SAVINGSACCOUNT")
            : !BOM.HasPermission("UPDATESAVINGSOFFICER_SAVINGSACCOUNT"),
          icon: <UserAddOutlined />,
        },
        {
          label: "Reject",
          key: "4",
          route: "/current-account-action",
          disabled: !BOM.HasPermission("REJECT_SAVINGSACCOUNT"),
          icon: <DislikeOutlined />,
        },
        {
          label: "Withdrawn by applicant",
          key: "5",
          route: "/current-account-action",
          disabled: !BOM.HasPermission("WITHDRAW_SAVINGSACCOUNT"),
          icon: <SettingOutlined />,
        },
        {
          label: "Add Charge",
          key: "6",
          route: "/current-account-action",
          disabled: !BOM.HasPermission("CREATE_SAVINGSACCOUNTCHARGE"),
          icon: <PlusOutlined />,
        },
      ];
    case accountStatus.approved:
      return [
        {
          label: "Undo Approval",
          key: "1",
          route: "/current-account-action",
          disabled: !BOM.HasPermission("APPROVALUNDO_SAVINGSACCOUNT"),
          icon: <SettingOutlined />,
        },
        {
          label: "Activate",
          key: "2",
          route: "/current-account-action",
          disabled: !BOM.HasPermission("ACTIVATE_SAVINGSACCOUNT"),
          icon: <CheckCircleOutlined />,
        },
        {
          label: "Add Charge",
          key: "3",
          route: "/current-account-action",
          disabled: !BOM.HasPermission("CREATE_SAVINGSACCOUNTCHARGE"),
          icon: <PlusOutlined />,
        },
        {
          label: fieldOfficerName ? "Unassign Officer" : "Assign Officer",
          key: "4",
          route: "/current-account-action",
          disabled: fieldOfficerName
            ? !BOM.HasPermission("REMOVESAVINGSOFFICER_SAVINGSACCOUNT")
            : !BOM.HasPermission("UPDATESAVINGSOFFICER_SAVINGSACCOUNT"),
          icon: <UserAddOutlined />,
        },
      ];
    case accountStatus.active:
      return [
        // {
        //   label: "Post Interest As On",
        //   key: "1",
        //   route: "/current-account-action",
        //   disabled:
        //     subStatusBlock || !BOM.HasPermission("POSTINTEREST_SAVINGSACCOUNT"),
        //   icon: <DoubleRightOutlined />,
        // },
        {
          label: "Deposit",
          key: "2",
          route: "/current-account-action",
          disabled:
            subStatusBlock || !BOM.HasPermission("DEPOSIT_SAVINGSACCOUNT"),
          icon: <UploadOutlined />,
        },
        {
          label: "Withdraw",
          key: "3",
          route: "/current-account-action",
          disabled:
            subStatusBlock || !BOM.HasPermission("WITHDRAWAL_SAVINGSACCOUNT"),
          icon: <DownloadOutlined />,
        },
        {
          label: "Calculate Interest",
          key: "4",
          // route: "/detail-current-account",
          disabled:
            subStatusBlock ||
            !BOM.HasPermission("CALCULATEINTEREST_SAVINGSACCOUNT"),
          icon: <CalculatorOutlined />,
        },
        {
          label: subStatusBlock ? "Unhold" : "Hold",
          key: "5",
          route: "/current-account-action",
          disabled: subStatusBlock
            ? subStatusNone
            : subStatusBlock || !BOM.HasPermission("HOLD_SAVINGSACCOUNT"),
          icon: <HolderOutlined />,
        },
        {
          label: fieldOfficerName ? "Unassign Officer" : "Assign Officer",
          key: "6",
          route: "/current-account-action",
          disabled: fieldOfficerName
            ? !BOM.HasPermission("REMOVESAVINGSOFFICER_SAVINGSACCOUNT")
            : !BOM.HasPermission("UPDATESAVINGSOFFICER_SAVINGSACCOUNT"),
          icon: <UserAddOutlined />,
        },
        // {
        //   label: "Post Interest",
        //   key: "7",
        //   // route: "/detail-current-account",
        //   disabled:
        //     subStatusBlock || !BOM.HasPermission("POSTINTEREST_SAVINGSACCOUNT"),
        //   icon: <SettingOutlined />,
        // },
        {
          label: "Add Charge",
          key: "8",
          route: "/current-account-action",
          disabled:
            subStatusBlock || !BOM.HasPermission("CREATE_SAVINGSACCOUNTCHARGE"),
          icon: <SettingOutlined />,
        },
        {
          label: "Close",
          key: "9",
          route: "/current-account-action",
          disabled:
            subStatusBlock || !BOM.HasPermission("CLOSE_SAVINGSACCOUNT"),
          icon: <SettingOutlined />,
        },
        // {
        //   label: "Manage Account",
        //   key: "10",
        //   route: "/current-account-action",
        //   disabled: subStatusBlock || !BOM.HasPermission("MANAGE_ACCOUNT"),
        //   icon: <SettingOutlined />,
        // },
        {
          label: "KYC",
          key: "11",
          route: "/current-account-action",
          disabled: subStatusBlock || !BOM.HasPermission("MANAGE_KYC"),
          icon: <SettingOutlined />,
        },
        {
          label: "Transfer Funds",
          key: "12",
          route: "/current-account-action",
          // disabled: true,
          disabled: subStatusBlock,
          icon: <UserAddOutlined />,
        },
        {
          label: "New Standing Instructions",
          key: "13",
          route: "/current-account-action",
          disabled: subStatusBlock,
          icon: <SettingOutlined />,
        },
      ];
    case accountStatus.block:
      return [
        {
          label: "Unhold Account",
          key: "1",
          route: "/unhold-account",
          disabled: !BOM.HasPermission("UNHOLD_SAVINGSACCOUNT"),
          icon: <HolderOutlined />,
        },
      ];
    case accountStatus.withdrawnByApplicant:
      return [
        {
          label: fieldOfficerName ? "Change Officer" : "Assign Officer",
          key: "1",
          route: "/current-account-action",
          disabled: !BOM.HasPermission("UPDATESAVINGSOFFICER_SAVINGSACCOUNT"),
          icon: <UserAddOutlined />,
        },
        {
          label: "Unassign Staff",
          key: "2",
          route: "/current-account-action",
          disabled: !BOM.HasPermission("REMOVESAVINGSOFFICER_SAVINGSACCOUNT"),
          icon: <UserAddOutlined />,
        },
      ];
    case accountStatus.closed:
      return [
        {
          label: fieldOfficerName ? "Change Officer" : "Assign Officer",
          key: "6",
          route: "/current-account-action",
          disabled: !BOM.HasPermission("UPDATESAVINGSOFFICER_SAVINGSACCOUNT"),
          icon: <UserAddOutlined />,
        },
      ];
    default:
      return [];
  }
};

export const handleLoanAccActionButtons = (accDetail) => {
  const { loanOfficerName } = accDetail;
  const status = accDetail?.status?.value;
  switch (status.toLowerCase()) {
    case accountStatus.submittedAndPending:
      return [
        {
          label: "Add Loan Charge",
          key: "1",
          route: "/add-loan-charge",
          disabled: !BOM.HasPermission("CREATE_LOANCHARGE"),
          icon: <SettingOutlined />,
        },
        {
          label: "Approve Loan Account",
          key: "2",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("APPROVE_LOAN"),
          icon: <SafetyOutlined />,
        },
        {
          label: "Reject Loan Account",
          key: "3",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("REJECT_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: loanOfficerName
            ? "Change Loan Officer"
            : "Assign Loan Officer",
          key: "4",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("UPDATELOANOFFICER_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Add Collateral",
          key: "5",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("CREATE_COLLATERAL"),
          icon: <SettingOutlined />,
        },
        {
          label: "Modify Application",
          key: "6",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("UPDATE_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Withdrawn By Client",
          key: "7",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("WITHDRAW_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "View Guarantors",
          key: "8",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("READ_GUARANTOR"),
          icon: <SettingOutlined />,
        },
        {
          label: "Create Guarantor",
          key: "9",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("CREATE_GUARANTOR"),
          icon: <SettingOutlined />,
        },
        {
          label: "Loan Screen Reports",
          key: "10",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("READ_LOAN"),
          icon: <SettingOutlined />,
        },
      ];
    case accountStatus.approved:
      return [
        {
          label: loanOfficerName
            ? "Change Loan Officer"
            : "Assign Loan Officer",
          key: "1",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("UPDATELOANOFFICER_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Disburse",
          key: "7",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("DISBURSE_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Disburse To Savings",
          key: "8",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("DISBURSETOSAVINGS_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Undo Approval",
          key: "2",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("APPROVALUNDO_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Add Loan Charge",
          key: "3",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("CREATE_LOANCHARGE"),
          icon: <SettingOutlined />,
        },
        {
          label: "View Guarantors",
          key: "4",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("READ_GUARANTOR"),
          icon: <SettingOutlined />,
        },
        {
          label: "Create Guarantor",
          key: "5",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("CREATE_GUARANTOR"),
          icon: <SettingOutlined />,
        },
        {
          label: "Loan Screen Reports",
          key: "6",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("READ_LOAN"),
          icon: <SettingOutlined />,
        },
      ];
    case accountStatus.active:
      return [
        {
          label: "Add Loan Charge",
          key: "1",
          route: "/add-loan-charge",
          disabled: !BOM.HasPermission("CREATE_LOANCHARGE"),
          icon: <SettingOutlined />,
        },
        {
          label: "Loan Prepayment",
          key: "2",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("REPAYMENT_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: loanOfficerName
            ? "Change Loan Officer"
            : "Assign Loan Officer",
          key: "3",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("UPDATELOANOFFICER_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Foreclosure",
          key: "4",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("FORECLOSURE_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Make Repayment",
          key: "5",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("REPAYMENT_LOAN"),
          icon: <SettingOutlined />,
        },

        {
          label: "Undo Disbursal",
          key: "6",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("DISBURSALUNDO_LOAN"),
          icon: <SettingOutlined />,
        },

        {
          label: "Waive Interest",
          key: "7",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("WAIVEINTERESTPORTION_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Reschedule",
          key: "8",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("CREATE_RESCHEDULELOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Write Off",
          key: "9",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("WRITEOFF_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Close",
          key: "10",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("CLOSE_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Close As Rescheduled",
          key: "11",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("CLOSEASRESCHEDULED_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Create Guarantor",
          key: "12",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("CREATE_GUARANTOR"),
          icon: <SettingOutlined />,
        },
        {
          label: "View Guarantor",
          key: "13",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("READ_GUARANTOR"),
          icon: <SettingOutlined />,
        },
        {
          label: "Recover From Guarantor",
          key: "14",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("RECOVERGUARANTEES_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Loan Screen Report",
          key: "15",
          route: "/loan-account-action",
          disabled: !BOM.HasPermission("READ_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "New Standing Instructions",
          key: "16",
          route: "/loan-account-action",
          // disabled: true,
          icon: <SettingOutlined />,
        },
      ];
    case accountStatus.closed:
      return [{}];
    case accountStatus.rejected:
      return [{}];
    default:
      return [];
  }
};
export const handleFixedDepositAccActionButtons = (accDetail) => {
  const { withHoldTax } = accDetail;
  const status = accDetail?.status?.value;

  switch (status.toLowerCase()) {
    case accountStatus.submittedAndPending:
      return [
        {
          label: "Modify Application",
          key: "1",
          route: "/fixed-deposit-account-action",
          disabled: !BOM.HasPermission("UPDATE_FIXEDDEPOSITACCOUNT"),
          icon: <EditOutlined />,
        },
        {
          label: "Approve",
          key: "2",
          route: "/fixed-deposit-account-action",
          disabled: !BOM.HasPermission("APPROVE_FIXEDDEPOSITACCOUNT"),
          icon: <SafetyOutlined />,
        },
        {
          label: "Reject",
          key: "4",
          route: "/fixed-deposit-account-action",
          disabled: !BOM.HasPermission("REJECT_FIXEDDEPOSITACCOUNT"),
          icon: <DislikeOutlined />,
        },
        {
          label: "Withdrawn by applicant",
          key: "5",
          route: "/fixed-deposit-account-action",
          disabled: !BOM.HasPermission("WITHDRAW_FIXEDDEPOSITACCOUNT"),
          icon: <SettingOutlined />,
        },
        {
          label: "Add Charge",
          key: "6",
          route: "/fixed-deposit-account-action",
          disabled: !BOM.HasPermission("CREATE_DEPOSITACCOUNTCHARGE"),
          icon: <SettingOutlined />,
        },
      ];
    case accountStatus.approved:
      return [
        {
          label: "Undo Approval",
          key: "1",
          route: "/fixed-deposit-account-action",
          disabled: !BOM.HasPermission("APPROVALUNDO_FIXEDDEPOSITACCOUNT"),
          icon: <SettingOutlined />,
        },
        {
          label: "Activate",
          key: "2",
          route: "/fixed-deposit-account-action",
          disabled: !BOM.HasPermission("ACTIVATE_FIXEDDEPOSITACCOUNT"),
          icon: <CheckCircleOutlined />,
        },
        {
          label: "Add Charge",
          key: "3",
          route: "/fixed-deposit-account-action",
          disabled: !BOM.HasPermission("CREATE_DEPOSITACCOUNTCHARGE"),
          icon: <PlusOutlined />,
        },
      ];
    case accountStatus.active:
      return [
        {
          label: "Premature Close",
          key: "1",
          route: "/fixed-deposit-account-action",
          disabled: !BOM.HasPermission("PREMATURECLOSE_FIXEDDEPOSITACCOUNT"),
          icon: <ArrowLeftOutlined />,
        },
        // {
        //   label: "Post Interest",
        //   key: "2",
        //   route: "/fixed-deposit-account-action",
        //   disabled: !BOM.HasPermission("POSTINTEREST_FIXEDDEPOSITACCOUNT"),
        //   icon: <DoubleRightOutlined />,
        // },
        {
          label: withHoldTax ? "Disable Withhold Tax" : "Enable Withhold Tax",
          key: "3",
          route: "/fixed-deposit-account-action",
          disabled: !BOM.HasPermission("UPDATEWITHHOLDTAXDEPOSITACCOUNT"),
          icon: <HolderOutlined />,
        },
        {
          label: "Add Charge",
          key: "4",
          route: "/fixed-deposit-account-action",
          disabled: !BOM.HasPermission("CREATE_DEPOSITACCOUNTCHARGE"),
          icon: <SettingOutlined />,
        },
        {
          label: "Manage Account",
          key: "6",
          route: "/fixed-deposit-account-action",
          disabled: !BOM.HasPermission("MANAGE_ACCOUNT"),
          icon: <SettingOutlined />,
        },
        {
          label: "Calculate Interest",
          key: "7",
          route: "/fixed-deposit-account-action",
          disabled: !BOM.HasPermission("CALCULATEINTEREST_FIXEDDEPOSITACCOUNT"),
          icon: <CalculatorOutlined />,
        },
      ];

    case accountStatus.withdrawnByApplicant:
      return [
        {
          label: "Unassign Staff",
          key: "2",
          route: "/current-account-action",
          disabled: !BOM.HasPermission("UPDATERDEPOSITOFFICER"),
          icon: <UserAddOutlined />,
        },
      ];
    case accountStatus.matured:
      return [
        {
          label: "Close",
          key: "1",
          route: "/fixed-deposit-account-action",
          disabled: !BOM.HasPermission("CLOSE_FIXEDDEPOSITACCOUNT"),
          icon: <CloseCircleOutlined />,
        },
        // {
        //   label: "Post Interest",
        //   key: "2",
        //   route: "/fixed-deposit-account-action",
        //   disabled: !BOM.HasPermission("POSTINTEREST_FIXEDDEPOSITACCOUNT"),
        //   icon: <DoubleRightOutlined />,
        // },
        {
          label: "Add Charge",
          key: "3",
          route: "/fixed-deposit-account-action",
          disabled: !BOM.HasPermission("CREATE_DEPOSITACCOUNTCHARGE"),
          icon: <SettingOutlined />,
        },
        {
          label: "Calculate Interest",
          key: "4",
          route: "/fixed-deposit-account-action",
          disabled: !BOM.HasPermission("CALCULATEINTEREST_FIXEDDEPOSITACCOUNT"),
          icon: <CalculatorOutlined />,
        },
      ];

    default:
      return [];
  }
};
export const handleRecurringDepositAccActionButtons = (accDetail) => {
  const { withHoldTax } = accDetail;
  const status = accDetail?.status?.value;

  console.log(status);
  switch (status.toLowerCase()) {
    case accountStatus.submittedAndPending:
      return [
        {
          label: "Modify Application",
          key: "1",
          route: "/recurring-deposit-account-action",
          disabled: !BOM.HasPermission("UPDATE_RECURRINGDEPOSITACCOUNT"),
          icon: <EditOutlined />,
        },
        {
          label: "Approve",
          key: "2",
          route: "/recurring-deposit-account-action",
          disabled: !BOM.HasPermission("APPROVE_RECURRINGDEPOSITACCOUNT"),
          icon: <SafetyOutlined />,
        },
        {
          label: "Reject",
          key: "4",
          route: "/recurring-deposit-account-action",
          disabled: !BOM.HasPermission("REJECT_RECURRINGDEPOSITACCOUNT"),
          icon: <DislikeOutlined />,
        },
        {
          label: "Withdrawn by applicant",
          key: "5",
          route: "/recurring-deposit-account-action",
          disabled: !BOM.HasPermission("WITHDRAW_RECURRINGDEPOSITACCOUNT"),
          icon: <DownloadOutlined />,
        },
        {
          label: "Add Charge",
          key: "6",
          route: "/recurring-deposit-account-action",
          disabled: !BOM.HasPermission("CREATE_DEPOSITACCOUNTCHARGE"),
          icon: <PlusOutlined />,
        },
      ];
    case accountStatus.approved:
      return [
        {
          label: "Undo Approval",
          key: "1",
          route: "/recurring-deposit-account-action",
          disabled: !BOM.HasPermission("APPROVALUNDO_RECURRINGDEPOSITACCOUNT"),
          icon: <SettingOutlined />,
        },
        {
          label: "Activate",
          key: "2",
          route: "/recurring-deposit-account-action",
          disabled: !BOM.HasPermission("ACTIVATE_RECURRINGDEPOSITACCOUNT"),
          icon: <CheckCircleOutlined />,
        },
      ];
    case accountStatus.active:
      return [
        {
          label: "Deposit",
          key: "1",
          route: "/recurring-deposit-account-action",
          disabled: !BOM.HasPermission("DEPOSIT_RECURRINGDEPOSITACCOUNT"),
          icon: <UploadOutlined />,
        },
        {
          label: "Withdraw",
          key: "2",
          route: "/recurring-deposit-account-action",
          disabled: !BOM.HasPermission("WITHDRAW_RECURRINGDEPOSITACCOUNT"),
          icon: <SwapOutlined />,
        },

        {
          label: "Calculate Interest",
          key: "3",
          disabled: !BOM.HasPermission(
            "CALCULATEINTEREST_RECURRINGDEPOSITACCOUNT"
          ),
          icon: <CalculatorOutlined />,
        },
        // {
        //   label: "Post Interest",
        //   key: "4",
        //   disabled: !BOM.HasPermission("POSTINTEREST_RECURRINGDEPOSITACCOUNT"),
        //   icon: <SettingOutlined />,
        // },
        {
          label: "Add Charge",
          key: "5",
          route: "/recurring-deposit-account-action",
          disabled: !BOM.HasPermission("CREATE_DEPOSITACCOUNTCHARGE"),
          icon: <SettingOutlined />,
        },
        {
          label: "Premature Close",
          key: "6",
          route: "/recurring-deposit-account-action",
          disabled: !BOM.HasPermission(
            "PREMATURECLOSE_RECURRINGDEPOSITACCOUNT"
          ),
          icon: <SettingOutlined />,
        },
        {
          label: withHoldTax ? "Disable Withhold Tax" : "Enable Withhold Tax",
          key: "7",
          route: "/recurring-deposit-account-action",
          disabled: withHoldTax
            ? !BOM.HasPermission("UPDATEWITHHOLDTAXDEPOSITACCOUNT")
            : true,
          icon: <HolderOutlined />,
        },
      ];
    case accountStatus.withdrawnByApplicant:
      return [];
    case accountStatus.matured:
      return [
        {
          label: "Transfer Funds",
          key: "1",
          route: "/recurring-deposit-account-action",
          disabled: !BOM.HasPermission("CLOSE_RECURRINGACCOUNT"),
          icon: <CloseCircleOutlined />,
        },
      ];

    default:
      return [];
  }
};

export const accountStatus = {
  submittedAndPending: "submitted and pending approval",
  approved: "approved",
  active: "active",
  block: "block",
  withdrawnByApplicant: "withdrawn by applicant",
  rejected: "rejected",
  closed: "closed",
  prematureClosed: "Premature Closed",
  matured: "matured",
};

export const AmountFormat = ({ amount, labelName, currency, precision }) => {
  return (
    <Statistic
      title={`${labelName ? labelName : "-"} ( ${currency ? currency : "-"} )`}
      prefix={currency}
      value={amount ? amount : 0}
      precision={precision ? precision : 2}
    />
  );
};

export const isDebit = (transactionType) => {
  return (
    transactionType?.withdrawal === true ||
    transactionType?.feeDeduction === true ||
    transactionType?.overdraftInterest === true ||
    transactionType?.withholdTax === true ||
    transactionType?.escheat === true ||
    transactionType?.forfeitInterest === true
  );
};
